import React from 'react'

export const CommentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.34557 14.0269C6.75131 14.748 8.36838 14.9434 9.90539 14.5777C11.4424 14.212 12.7983 13.3094 13.7287 12.0325C14.6591 10.7556 15.1028 9.1884 14.9799 7.61328C14.857 6.03815 14.1756 4.55871 13.0584 3.44155C11.9413 2.32439 10.4618 1.64297 8.88672 1.52009C7.3116 1.39721 5.74439 1.84095 4.46749 2.77134C3.19059 3.70174 2.28798 5.0576 1.92231 6.59461C1.55664 8.13162 1.75196 9.74869 2.47307 11.1544L1 15.5L5.34557 14.0269Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
